<template>
<div class="chapter">
<div class="inner_page">
<h1 class="western2" id="calibre_pb_8"><a id="CHAPTER02"></a>
CHAPTER 2</h1>
<p class="western1"> <br class="calibre2"/></p>
<p class="western1"> <br class="calibre2"/></p>
<p class="c10">July 30</p>
<p class="western1">“It does feel like we’re moving fast on this,
doesn’t it?” Mark commented over our lunch of soup.</p>
<p class="western1">“Having second thoughts?” I asked, worried
that he might be trying to back out.</p>
<p class="western1">“Oh, no, not at all!” He set his spoon down,
stood and coaxed me into his arms. “It’s overwhelming, you know?
It’s all happening so quickly.”</p>
<p class="western1">“I know it is, Mark, and this new world is
very tenuous. I want every bit of happiness we can find, and I want
to hold on to it. We don’t know what tomorrow will bring, and I
don’t want to miss a bit of today!” I stroked his smooth cheek with
my palm. “Would you rather wait a week or maybe a month?”</p>
<p class="western1">“No! I want you as my wife, now if I could. I
want <i class="calibre4">you</i> to be sure,” he said.</p>
<p class="western1">“Oh, I’m sure. If you’re finished with lunch,
let’s go talk to Pastor Carolyn.”</p>
<p class="western1"> <br class="calibre2"/></p>
<p class="c">~~~</p>
<p class="c"> <br class="calibre2"/></p>
<p class="western1">It was another beautiful day with clear skies
and a steady temperature around seventy-five degrees, a good ten
degrees cooler than normal. We even drove with the windows
down.</p>
<p class="western1">As I got closer into Moose Creek, something
felt different… off. I couldn’t quite put my finger on it until we
saw the military truck turning the corner several blocks ahead of
us. Fortunately it was heading in the same direction and turned
away, out of sight.</p>
<p class="western1">“I’m guessing that’s not a good thing to
see,” Mark commented.</p>
<p class="western1">“Not as far as I’m concerned it isn’t!” I
made a quick right turn, pulling into Bob and Kathy’s long hidden
driveway. I stopped in front of their large storage barn and
parked. Normally I’d pull closer to the house, but I wanted to make
sure the car wasn’t visible from the road and the huge building hid
it well.</p>
<p class="western1">“Follow me,” I said to Mark, edging my way
along the side of their house where it was sheltered with shrubs. I
moved quickly along the emerging wall of the walk out basement and
was soon looking at their screened in lower deck with the upper
deck facing the lake. We were in luck; they were sitting up there
enjoying the day.</p>
<p class="western1">“Hey up there!” I called out, and Kathy
peered over the side.</p>
<p class="western1">“What are you doing down there? Why didn’t
you come to the front door?” she questioned.</p>
<p class="western1">“Because we’ve got company! Is this door
open?”</p>
<p class="western1">“No, I’ll be right down though.” She
backtracked through the house and came out near us, unlocking the
glass door, and then unlocking the screen so we could come in.</p>
<p class="western1">Bob was right behind her looking worried.
“Who is the company, Allexa?” he asked.</p>
<p class="western1">“The military!” I said once we were inside.
“We were coming here to see Carolyn when we saw a truck turn up
Dutch Street. Once they turned I pulled in here and parked up near
the barn.”</p>
<p class="western1">“I wonder where they were going, or what
they’re looking for,” Bob wondered out loud.</p>
<p class="western1">“My guess is they’re looking for survivors,
maybe to help, but maybe to take them to the ‘Relocation Center’.
Either way, I don’t want to be found, at least not until we know
for sure.”</p>
<p class="western1">“But we really came to see Carolyn,” Mark
told them. “Is she around?”</p>
<p class="western1">“She’s spending some alone time at her house
at the top of the driveway. I guess we can be a bit overwhelming at
times,” Kathy chuckled. “Is it something important? We can go get
her if you want.”</p>
<p class="western1">“Well, <i class="calibre4">we</i> think it’s important,” I
said, smiling. “Go ahead, Mark, tell them.”</p>
<p class="western1">My two friends turned to him.</p>
<p class="western1">“Allex has agreed to marry me,” Mark
announced. “We want Carolyn to do us the honors.”</p>
<p class="western1">Bob looked shocked, and Kathy was all grins.
“Oh, that is just wonderful! When is this going to happen?” she
asked.</p>
<p class="western1">“As soon as we can make all the arrangements,
but we’re thinking Thursday.”</p>
<p class="western1">“That’s three days away!” Kathy
exclaimed.</p>
<p class="western1">“I know, we would rather it be this
afternoon, but August second is the day we decided on.”</p>
<p class="western1">Mark and I had discussed that John asked me
to wait two weeks for his return, and though we were both sure he
wasn’t coming back, and it wouldn’t matter if he did, it was a
symbolic gesture. August second was the end of the two weeks, I
didn’t feel the need to share that with Bob and Kathy just yet.</p>
<p class="western1">“That’s not what I meant,” she laughed.
“Three more days is really soon. Is that enough time to do
everything? To get all the preparations done? What about a dress?
And a reception? And that means food. Are you sending out
invitations? Oh my.” She dropped down into a chair. “What can I do
to help?”</p>
<p class="western1">I had to laugh. Kathy is the most organized
person I’ve ever met, however, she likes having time to make
everything just right.</p>
<p class="western1">I took my friend’s hand. “Kathy, we don’t
need much. We would like our friends to be with us that afternoon,
to witness our joining. After Carolyn performs the ceremony, we’ll
have an early supper. That’s all.”</p>
<p class="western1">“That’s all?? What about food? What about a
gift?” she was more nervous about this than I was.</p>
<p class="western1">“No gifts. Your presence is our present,” I
told her. When I saw she had that look of determination on her face
that I’ve come to know, I said, “Look, if you want something to do,
make a dish to pass. And come early to help me set up and then get
dressed. Okay?” That seemed to satisfy her.</p>
<p class="western1"> <br class="calibre2"/></p>
<p class="western1">We left the car beside the barn while we
walked up to Carolyn’s house. It was an impressive log house to
begin with, shining with its deep glow of amber stain, now even
more so with the addition of a matching garage and loft apartment,
all attached by an enclosed two-story glass breezeway. All of that
space and she lived alone. I never understood the need for all
those rooms. She answered on the first ring.</p>
<p class="western1">“What an unexpected surprise! Come in,
Allexa, Mark. What can I do for you?” She was now in her best
pastoral mode.</p>
<p class="western1">I got right to the point. “Well, Pastor, Mark
and I want to be married and we would like you to perform the
ceremony for us. This Thursday at four o’clock in the afternoon. We
will be providing a buffet dinner afterward. Will this fit in your
schedule?” I asked with a slight snicker, knowing she probably
didn’t have much going on.</p>
<p class="western1">She smiled broadly at us. “It would be my
honor and my pleasure.” Mark and I were holding hands, so she took
hold of our free hands, completing a circle. “This is wonderful,
Allexa, it gives me hope for a future; a future I haven’t been too
sure about lately.”</p>
<p class="c"> <br class="calibre2"/></p>
<p class="c">~~~</p>
<p class="c"> <br class="calibre2"/></p>
<p class="western1">“I think I heard that military truck drive
past while we were in with Carolyn,” Mark mentioned on our walk
back down the driveway to the car.</p>
<p class="western1">“I heard it too, so it’s probably safe to
leave. Damn! I hate being so paranoid. They might want a head count
to send some supplies in,” I sighed.</p>
<p class="western1">“You don’t really believe that, do you?” he
said to me.</p>
<p class="western1">“No I don’t,” I sighed. “Sometimes it pays to
be paranoid.” I started the car and backed up. “I’d like to stop
and see Pete and Lenny, tell them about the wedding. Is that okay
with you?”</p>
<p class="western1">“Of course.” Mark leaned over and gave me a
quick kiss. “They’re our friends, part of <i class="calibre4">our</i> circle.”</p>
<p class="western1"> <br class="calibre2"/></p>
<p class="c">~~~</p>
<p class="c"> <br class="calibre2"/></p>
<p class="western1">Pete’s white and maroon bungalow sat on a
corner lot and was only a block away so we saw the smoke
immediately. I pulled in on the side street, where we saw the
overturned grill, wood chips spilling out, singeing the brown
grass. No one answered our calls, so we got some water from the
rain barrel and doused the fire.</p>
<p class="western1">“What do you think happened, Allex?” Mark
asked absentmindedly as we left Moose Creek.</p>
<p class="western1">“I’m not sure. Did you see any food on the
ground?” I asked.</p>
<p class="western1">“No, I could smell that something had been
cooking though,” he answered.</p>
<p class="western1">“Same here, and it smelled like meat cooking,
perhaps some of that venison.” I thought for a few moments, driving
slowly by the burnt out shell of the Shoreline Treasures building
that had succumbed to arson last December.</p>
<p class="western1">I then passed Fram’s store. It was closed,
windows boarded over. I had talked with Joe only a week ago and
recalled that he was considering moving to his camp deep in the
woods to ride out the ash cloud.</p>
<p class="western1">“It’s only a theory, however, it’s possible
that when the military truck came back through, they smelled the
cooking too and followed the scent to Pete’s. I know it’s a
stretch, but I think there was a struggle and they forced Pete and
Lenny to go with them back to Marquette. And that whoever was in
that truck took the food. It would be like Lenny to leave us a clue
like the overturned grill, so we knew they didn’t go willingly,” I
said.</p>
<p class="western1">“Let’s run your theory by Eric. He’s the one
with the military experience.” Mark looked sullen, worried, and a
bit frightened. “I think we need to be very cautious, Allex.”</p>
<p class="western1">“I agree, but I’m not going to let this
interfere with our wedding!”</p>
<p class="western1"> <br class="calibre2"/></p>
<p class="c">~~~</p>
<p class="c"> <br class="calibre2"/></p>
<p class="western1">“Well,” Eric said, his foot propped up on a
pillow, and “I think Mom might be right about this, Doc, but I
don’t understand it. This isn’t a thing the military would usually
do. Why would they <i class="calibre4">force</i> help on someone who is obviously
not in need of help? Unless…” he paused while thinking. “Unless it
isn’t about helping them. Maybe they looked at Pete and Lenny as
being a threat somehow, and they were sent out to eliminate
threats.”</p>
<p class="western1">“Now that’s a scary thought,” I said to Eric.
“What if they consider <i class="calibre4">anyone</i> not in their control a threat?
That would mean rounding <i class="calibre4">everyone</i> up. What threat could a
handful of loners be?”</p>
<p class="western1">Jason looked at me and laughed. “Say, Mom,
you have a copy of <i class="calibre4">Red Dawn</i>?”</p>
<p class="western1">“Sure, but why…” Thinking about the movie I
answered my own question. “Point made, Jason. Thank you. The
military— or whoever is really in control— is afraid the lone wolfs
might start a rebellion against their power.” I shook my head.
“Don’t they and <i class="calibre4">we</i> have enough to worry about without this
too??” I stood and started pacing.</p>
<p class="western1">“I suggest we limit outdoor activities for a
week or so, let them look around town, see no one else is there and
maybe they’ll go away,” Eric said. “We’ll keep the kids inside, or
limit their play area. Same for Chivas, she’s still recovering and
has adapted well to the grass box. Oh, and have you noticed that
she hasn’t barked? I’ve been working with her on that.”</p>
<p class="western1">“Well, weather permitting I still want to
have the wedding outside. Other than that, Eric, I agree; we need
to keep a low profile until we know what they want.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_648f5cba11b35594391da1bef1608eec_YkgYR9.ch.fixed.fc.tidied.stylehacked.xfixed_split_009.vue?c189b6fc